import { createContext } from "react";
import { useAuthenticationScope } from "../shared/hooks";

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const value = useAuthenticationScope();
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
